import styled, { css } from 'styled-components';
import media from 'styled-media-query';

export const Container = styled.section`
  width: 100%;

  ${({ theme }) => css`
    .slick-dots {
      list-style: none;
      display: flex !important;
      align-items: center;
      justify-content: center;
      margin-top: ${theme.spacings.xsmall};

      border-radius: calc(${theme.border.radius.large} * 2);
      background: transparent;

      li {
        background: ${theme.colors.border};
        width: 1rem;
        height: 1rem;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 ${theme.spacings.xsmall};
        cursor: pointer;

        &.slick-active {
          background: ${theme.colors.primary};
        }
      }

      button {
        opacity: 0;
        width: 0.5rem;
        height: 0.5rem;
        cursor: pointer;
      }

      ${media.lessThan('small')`
        display: none !important;
      `}
    }

    .slick-slide {
      padding: 0 1.5rem;

      &.slick-active.slick-current {
        visibility: visible;
      }
    }

    ${media.lessThan('large')`
      .slick-slide {
        padding: 0 1.5rem 0 0;
      }
    `}

    svg {
      color: ${theme.colors.primary};
    }
  `}
`;
